<ng-container *ngIf="loadingState$ | async">
  <div class="spinner-container">
    <div class="backdrop"></div>
    <mat-spinner class="spinner"></mat-spinner>
  </div>
</ng-container>
<router-outlet></router-outlet>
